import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import { useSlideImageActive } from 'js/shared/swiper/useSlideImageActive'
import styles from './sliderImage.scss'

const cx = classNames.bind(styles);

export const imageProportions = {
  'md': '16x9',
  'lg': '4x3',
  'square': '1x1',
  'auto': 'auto',
};

const SliderImage = ({
  src,
  mobile,
  alt,
  title,
  proportion = 'auto',
  width,
  height,
}) => {
  const { ref, active } = useSlideImageActive()

  return (
    <div ref={ref} className={cx('slider-image', `proportion-${imageProportions[proportion]}`)}>
      <picture>
        {mobile && mobile.length > 0 ? mobile.map((item) => (
          <source
            key={`${item.media}-${item.src}`}
            srcSet={active ? item.src : undefined}
            data-srcset={active ? undefined : item.src}
            media={item.media}
          />
        )) : null}
        <img
          src={active ? src : undefined}
          data-src={active ? undefined : src}
          width={width}
          height={height}
          alt={alt}
          title={title}
          loading="lazy"
        />
      </picture>
    </div>
  )
}

SliderImage.propTypes = {
  src: PropTypes.string.isRequired,
  mobile: PropTypes.arrayOf(
    PropTypes.shape({
      width: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired,
    }),
  ),
  alt: PropTypes.string,
  title: PropTypes.string,
}

export default SliderImage
